import { connect } from 'react-redux';

import flatten from 'lodash/flatten';
import { trackActions, RootState, Dispatch } from '../../api';

import TracksList, {
  StateProps,
  DispatchProps,
  OwnProps,
} from '../../components/TracksList';

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  (
    { tracks: { entries, userTracks, isFetchingUserTracks } }: RootState,
    { id: userId },
  ) => {
    const tracksForUser = userId !== undefined ? userTracks[userId] : undefined;
    const data = tracksForUser ? tracksForUser.data : {};
    const tracks = tracksForUser
      ? flatten(Object.values(data)).map((id: number) => entries[id])
      : [];

    const pagination = tracksForUser && tracksForUser.pagination;
    return {
      tracks: tracks.filter((t) => t.status !== 'uploaded'),
      isProfilePage: true,
      isFetching: isFetchingUserTracks,
      currentPage: pagination ? pagination.currentPage : 1,
      lastPageReached: pagination
        ? pagination.currentPage >= pagination.lastPage
        : false,
      playlistType: 'userPlaylist',
    };
  },

  (dispatch: Dispatch) => ({
    fetchTracks: ({ id, page = 1 }: { id?: number; page?: number }) => {
      dispatch(
        trackActions.fetchUserTracks(Number(id), { page, sort: 'date' }),
      );
    },
  }),
)(TracksList);
